import { render, staticRenderFns } from "./Hello.vue?vue&type=template&id=587423c3&scoped=true&lang=pug"
import script from "./Hello.vue?vue&type=script&lang=ts"
export * from "./Hello.vue?vue&type=script&lang=ts"
import style0 from "./Hello.vue?vue&type=style&index=0&id=587423c3&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587423c3",
  null
  
)

export default component.exports